(function () {
  var RESTORE_DELAYS = [0, 50, 150, 300, 600];
  var memory = (window.__variantSelectionMemory =
    window.__variantSelectionMemory || {});

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  function text(value) {
    return String(value || '').trim();
  }

  function getContainer(element) {
    return (
      element.closest('quick-add-modal') ||
      element.closest('.quick-add-modal') ||
      element.closest('[id^="QuickAdd-"]') ||
      element.closest('product-info') ||
      element.closest('.product') ||
      document
    );
  }

  function getForm(scope, dropdown, picker) {
    var formId = dropdown && dropdown.getAttribute('form');
    var container = getContainer(picker || dropdown);

    return (
      (formId && document.getElementById(formId)) ||
      container.querySelector('form[data-type="add-to-cart-form"]') ||
      container.querySelector('form[action*="/cart/add"]') ||
      (dropdown && dropdown.closest('form'))
    );
  }

  function getButtonTextElement(button) {
    if (!button) return null;

    return button.querySelector(
      '.button-text, span:not(.loading__spinner):not(.sold-out-message):not(.variant-price)'
    );
  }

  function setButtonText(button, value) {
    var element = getButtonTextElement(button);

    if (element) {
      element.textContent = value;
    } else if (button) {
      button.textContent = value;
    }
  }

  function getGroups(picker) {
    if (!picker) return [];
    return Array.from(
      picker.querySelectorAll('[data-variant-option]')
    );
  }

  function getGroupName(group) {
    if (!group) return 'option';
    if (group.dataset.optionName) return group.dataset.optionName;

    var label = group.querySelector('legend, label');
    var value = label ? label.childNodes[0].textContent : '';

    return text(value).replace(':', '') || 'option';
  }

  function isSizeGroup(group) {
    return (
      group &&
      (group.matches('fieldset.sizeoptions, .sizeoptions') ||
        normalize(getGroupName(group)) === 'size')
    );
  }

  function getGroupControl(group) {
    if (!group) return null;

    return (
      group.querySelector('input[type="radio"]:checked') ||
      group.querySelector('select')
    );
  }

  function getGroupValue(group, state) {
    var control;

    if (isSizeGroup(group)) {
      return state.variantId && state.size ? state.size : '';
    }

    control = getGroupControl(group);
    return control ? control.value || '' : '';
  }

  function setGroupLabel(group, value) {
    var label = group && group.querySelector('[data-selected-value]');
    var name;

    if (!label) return;

    name = getGroupName(group).toLowerCase();
    value = value || 'Choose ' + name;

    if (label.textContent !== value) {
      label.textContent = value;
    }
  }

  function clearGroup(group) {
    var select;
    var placeholder;

    if (!group) return;

    group
      .querySelectorAll('input[type="radio"]')
      .forEach(function (radio) {
        radio.checked = false;
        radio.removeAttribute('checked');
        radio.setAttribute('aria-checked', 'false');
      });

    select = group.querySelector('select');

    if (select) {
      placeholder = select.querySelector('option[value=""]');
      select.value = placeholder ? '' : '';
      select.selectedIndex = placeholder ? placeholder.index : -1;
    }

    setGroupLabel(group, '');
    group.classList.remove('variant-option-error');
  }

  function parseVariants(dropdown) {
    return Array.from(dropdown.options)
      .filter(function (option) {
        return Boolean(option.value);
      })
      .map(function (option) {
        return {
          id: option.value,
          size: option.dataset.size || option.text || option.value,
          color: option.dataset.color || '',
          group: option.dataset.group || '',
          price: option.dataset.price || '',
          available: option.dataset.available !== 'false',
          option: option
        };
      });
  }

  function initCustomSizeSelector(root) {
    var scope = root || document;
    var picker = scope.matches && scope.matches('variant-selects')
      ? scope
      : scope.querySelector('variant-selects');
    var container = picker ? getContainer(picker) : scope;
    var dropdown =
      container.querySelector('#SizeDropdown') ||
      scope.querySelector('#SizeDropdown');
    var customSelect =
      container.querySelector('#CustomSizeSelect') ||
      scope.querySelector('#CustomSizeSelect');

    if (!picker || !dropdown || !customSelect) return;
    if (
      customSelect.dataset.initialized === 'true' &&
      customSelect.__customVariantPicker === picker
    ) {
      if (customSelect.__customVariantRestore) {
        customSelect.__customVariantRestore();
      }

      return;
    }

    if (customSelect.__customVariantAbort) {
      customSelect.__customVariantAbort.abort();
    }

    customSelect.__customVariantAbort = new AbortController();
    customSelect.dataset.initialized = 'true';
    customSelect.__customVariantPicker = picker;

    var form = getForm(scope, dropdown, picker);
    var optionsBox = customSelect.querySelector('.custom-size-options');
    var selectedBox = customSelect.querySelector('.custom-size-selected');
    var selectedTitle = customSelect.querySelector('.custom-size-title');
    var selectedPrice = customSelect.querySelector('.custom-size-price');
    var errorMessage = picker.querySelector('.manual-variant-error');
    var addButton = form
      ? form.querySelector('button[name="add"], .product-form__submit')
      : null;
    var variantInput = form
      ? form.querySelector('input[name="id"]')
      : null;
    var variants = parseVariants(dropdown);
    var state = {
      interacted: false,
      group: '',
      size: '',
      price: '',
      variantId: ''
    };
    var syncingSize = false;
    var signal = customSelect.__customVariantAbort.signal;

    if (!form || !optionsBox || !variants.length) return;

    if (!errorMessage) {
      errorMessage = document.createElement('div');
      errorMessage.className = 'manual-variant-error';
      errorMessage.setAttribute('role', 'alert');
      errorMessage.hidden = true;
      picker.appendChild(errorMessage);
    }

    if (addButton && !addButton.dataset.originalText) {
      addButton.dataset.originalText =
        text(getButtonTextElement(addButton) &&
          getButtonTextElement(addButton).textContent) ||
        text(addButton.textContent) ||
        'Add to cart';
    }

    function selectedColor() {
      var colorGroup = getGroups(picker).find(function (group) {
        var groupName = normalize(getGroupName(group));

        return (
          groupName === 'color' ||
          groupName === 'colour' ||
          groupName.indexOf('color') !== -1 ||
          groupName.indexOf('colour') !== -1
        );
      });

      var control = getGroupControl(colorGroup);

      return control ? control.value || '' : '';
    }

    function activeGroup() {
      var tab = container.querySelector('.tab-btn.active');
      return tab ? tab.dataset.tab || '' : '';
    }

    function matchingVariants() {
      var selectedColorValue = normalize(selectedColor());
      var selectedGroupValue = normalize(activeGroup());
      var seen = {};

      var colorVariants = variants.filter(function (variant) {
        var variantColor = normalize(variant.color);

        return (
          !selectedColorValue ||
          !variantColor ||
          variantColor === selectedColorValue
        );
      });

if (!colorVariants.length) {
  return [];
}

      var filteredVariants = colorVariants;

      if (selectedGroupValue) {
        var groupVariants = colorVariants.filter(function (variant) {
          var variantGroup = normalize(variant.group);
          var variantSize = normalize(variant.size);

          return (
            variantGroup === selectedGroupValue ||
            variantSize.indexOf(selectedGroupValue) === 0
          );
        });

 
        if (groupVariants.length) {
          filteredVariants = groupVariants;
        }
      }

      return filteredVariants.filter(function (variant) {
        var key = normalize(variant.size);

        if (!key || seen[key]) {
          return false;
        }

        seen[key] = true;
        return true;
      });
    }

    function findVariantBySize(size) {
      return matchingVariants().find(function (variant) {
        return normalize(variant.size) === normalize(size);
      });
    }

    function getMissingGroups() {
      return getGroups(picker).filter(function (group) {
        return !getGroupValue(group, state);
      });
    }

    function isComplete() {
      return (
        getGroups(picker).length > 0 &&
        getMissingGroups().length === 0 &&
        Boolean(state.variantId) &&
        (!variantInput || Boolean(variantInput.value))
      );
    }

    function setRequiredButton() {
      if (!addButton) return;

      addButton.disabled = false;
      addButton.removeAttribute('disabled');
      addButton.dataset.variantRequired = 'true';
      addButton.setAttribute('aria-disabled', 'true');
      addButton.classList.add('manual-options-disabled');
      setButtonText(addButton, 'Choose options');
    }

    function setReadyButton() {
      if (!addButton) return;

      addButton.disabled = false;
      addButton.removeAttribute('disabled');
      addButton.dataset.variantRequired = 'false';
      addButton.setAttribute('aria-disabled', 'false');
      addButton.classList.remove('manual-options-disabled');
      setButtonText(
        addButton,
        addButton.dataset.originalText || 'Add to cart'
      );
    }

    function hideErrors() {
      getGroups(picker).forEach(function (group) {
        group.classList.remove('variant-option-error');
      });

      customSelect.classList.remove('variant-group-error');
      errorMessage.hidden = true;
      errorMessage.textContent = '';
    }

    function showErrors() {
      var missing = getMissingGroups();
      var names = missing.map(getGroupName);
      var first = missing[0] || customSelect;

      missing.forEach(function (group) {
        group.classList.add('variant-option-error');

        if (isSizeGroup(group)) {
          customSelect.classList.add('variant-group-error');
        }
      });

      errorMessage.textContent =
        'Please select ' + names.join(' and ') + '.';
      errorMessage.hidden = false;

      first.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    function updateFormVariant(variant) {
      dropdown.value = variant ? variant.id : '';
      dropdown.selectedIndex = variant
        ? Array.from(dropdown.options).indexOf(variant.option)
        : -1;

      if (variantInput) {
        variantInput.disabled = false;
        variantInput.value = variant ? variant.id : '';
        variantInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    }

    function syncSizeRadio(shouldDispatch) {
      var sizeGroup = getGroups(picker).find(isSizeGroup);
      var radios = sizeGroup
        ? Array.from(sizeGroup.querySelectorAll('input[type="radio"]'))
        : [];
      var match = radios.find(function (radio) {
        return normalize(radio.value) === normalize(state.size);
      });

      radios.forEach(function (radio) {
        if (radio === match) return;

        if (radio.checked) {
          radio.checked = false;
        }

        if (radio.hasAttribute('checked')) {
          radio.removeAttribute('checked');
        }

        if (radio.getAttribute('aria-checked') !== 'false') {
          radio.setAttribute('aria-checked', 'false');
        }
      });

      if (!match) {
        setGroupLabel(sizeGroup, '');
        return;
      }

      if (!match.checked) {
        match.checked = true;
      }

      if (match.getAttribute('checked') !== 'checked') {
        match.setAttribute('checked', 'checked');
      }

      if (match.getAttribute('aria-checked') !== 'true') {
        match.setAttribute('aria-checked', 'true');
      }
      setGroupLabel(sizeGroup, state.size);

      if (shouldDispatch) {
        syncingSize = true;
        match.dispatchEvent(new Event('input', { bubbles: true }));
        match.dispatchEvent(new Event('change', { bubbles: true }));
        syncingSize = false;
      }
    }

    function updatePrices() {
      var buttonPrice = form.querySelector(
        '.product-form__submit .variant-price'
      );
      var pagePrice = container.querySelector(
        '.price__regular .price-item--regular'
      );

      if (buttonPrice && state.price) {
        buttonPrice.textContent = state.price;
      }

      if (pagePrice && state.price) {
        pagePrice.textContent = state.price;
      }
    }

    function memoryKeys() {
      return [
        picker.id,
        picker.dataset.section,
        form.id,
        container.id,
        window.location.pathname
      ].filter(Boolean);
    }

    function getSavedState() {
      var keys = memoryKeys();
      var saved = null;

      keys.some(function (key) {
        saved = memory[key];
        return Boolean(saved);
      });

      return saved;
    }

    function getSelectedOptions() {
      var options = {};

      getGroups(picker).forEach(function (group) {
        var name = getGroupName(group);
        var control;

        if (!name || isSizeGroup(group)) return;

        control = getGroupControl(group);

        if (control && control.value) {
          options[name] = control.value;
        }
      });

      return options;
    }

    function saveState() {
      var saved = {
        interacted: state.interacted,
        group: state.group,
        size: state.size,
        price: state.price,
        variantId: state.variantId,
        color: selectedColor(),
        options: getSelectedOptions()
      };

      memoryKeys().forEach(function (key) {
        memory[key] = saved;
      });
    }

    function renderSizeOptions() {
      if (signal.aborted) return;

      optionsBox.innerHTML = '';

      matchingVariants().forEach(function (variant) {
        var item = document.createElement('div');

        item.className = 'custom-size-option';
        item.dataset.value = variant.id;

        if (state.variantId === variant.id) {
          item.classList.add('selected');
        }

if (!variant.available) {
  item.classList.add('disabled', 'sold-out');
  item.setAttribute('aria-disabled', 'true');
  item.setAttribute('tabindex', '-1');

  item.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
  });
} else {
  item.setAttribute('role', 'option');
  item.setAttribute('tabindex', '0');

  item.addEventListener('click', function () {
    selectVariant(variant);
    customSelect.classList.remove('open');
  });

  item.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    selectVariant(variant);
    customSelect.classList.remove('open');
  });
}

        item.innerHTML =
          '<span class="custom-size-option-title">' +
          variant.size +
          '</span><span class="custom-size-option-price">' +
          variant.price +
          '</span>';

        optionsBox.appendChild(item);
      });
    }

    function render() {
      var complete;

      if (signal.aborted) return;

      renderSizeOptions();

      if (selectedTitle) {
        selectedTitle.textContent = state.size || 'Choose a size';
      }

      if (selectedPrice) {
        selectedPrice.textContent = state.price || '';
      }

      updateFormVariant(
        state.variantId
          ? variants.find(function (variant) {
              return variant.id === state.variantId;
            })
          : null
      );

      updatePrices();

      complete = isComplete();
      form.dataset.customVariantSelected = state.variantId
        ? 'true'
        : 'false';
      form.dataset.allVariantOptionsSelected = complete
        ? 'true'
        : 'false';

      if (complete) {
        hideErrors();
        setReadyButton();
      } else {
        setRequiredButton();
      }
    }

    function selectVariant(variant) {
      if (signal.aborted) return;
      if (!variant || !variant.available) return;

      state.interacted = true;
      state.group = variant.group || activeGroup();
      state.size = variant.size;
      state.price = variant.price;
      state.variantId = variant.id;

      syncSizeRadio(true);
      customSelect.classList.remove('variant-group-error');
      saveState();
      render();
    }

    function clearDefaults() {
      if (signal.aborted) return;
      if (state.interacted) return;

      getGroups(picker).forEach(clearGroup);

      state.group = activeGroup();
      state.size = '';
      state.price = '';
      state.variantId = '';

      hideErrors();
      render();
    }

    function restoreFromMemory() {
      var saved = getSavedState();
      var variant;
      var colorGroup;
      var colorControl;
      var savedOptions;

      if (signal.aborted) return false;
      if (!saved || saved.interacted !== true) return false;

      state.interacted = true;
      state.group = saved.group || activeGroup();
      savedOptions = saved.options || {};

      getGroups(picker).forEach(function (group) {
        var name = getGroupName(group);
        var savedValue = savedOptions[name];
        var radios;
        var matchingRadio;
        var select;

        if (!savedValue || isSizeGroup(group)) return;

        radios = Array.from(
          group.querySelectorAll('input[type="radio"]')
        );

        if (radios.length) {
          matchingRadio = radios.find(function (radio) {
            return normalize(radio.value) === normalize(savedValue);
          });

          if (matchingRadio) {
            radios.forEach(function (radio) {
              if (radio === matchingRadio) return;

              if (radio.checked) {
                radio.checked = false;
              }

              if (radio.hasAttribute('checked')) {
                radio.removeAttribute('checked');
              }

              if (radio.getAttribute('aria-checked') !== 'false') {
                radio.setAttribute('aria-checked', 'false');
              }
            });

            if (!matchingRadio.checked) {
              matchingRadio.checked = true;
            }

            if (
              matchingRadio.getAttribute('checked') !== 'checked'
            ) {
              matchingRadio.setAttribute('checked', 'checked');
            }

            if (
              matchingRadio.getAttribute('aria-checked') !== 'true'
            ) {
              matchingRadio.setAttribute('aria-checked', 'true');
            }

            setGroupLabel(group, savedValue);
          }
        } else {
          select = group.querySelector('select');

          if (select) {
            select.value = savedValue;
            setGroupLabel(group, savedValue);
          }
        }
      });

      if (saved.color) {
        colorGroup = getGroups(picker).find(function (group) {
          return normalize(getGroupName(group)) === 'color';
        });

        if (colorGroup) {
          colorControl =
            Array.from(
              colorGroup.querySelectorAll('input[type="radio"]')
            ).find(function (radio) {
              return normalize(radio.value) === normalize(saved.color);
            }) || colorGroup.querySelector('select');

          if (colorControl) {
            if (colorControl.type === 'radio') {
              colorGroup
                .querySelectorAll('input[type="radio"]')
                .forEach(function (radio) {
                  if (radio === colorControl) return;

                  if (radio.checked) {
                    radio.checked = false;
                  }

                  if (radio.hasAttribute('checked')) {
                    radio.removeAttribute('checked');
                  }

                  if (radio.getAttribute('aria-checked') !== 'false') {
                    radio.setAttribute('aria-checked', 'false');
                  }
                });

              if (!colorControl.checked) {
                colorControl.checked = true;
              }

              if (colorControl.getAttribute('checked') !== 'checked') {
                colorControl.setAttribute('checked', 'checked');
              }

              if (colorControl.getAttribute('aria-checked') !== 'true') {
                colorControl.setAttribute('aria-checked', 'true');
              }
            } else {
              colorControl.value = saved.color;
            }

            setGroupLabel(colorGroup, saved.color);
          }
        }
      }

      variant =
        variants.find(function (item) {
          return item.id === saved.variantId;
        }) || findVariantBySize(saved.size);

      if (variant) {
        state.size = variant.size;
        state.price = variant.price;
        state.variantId = variant.id;
        syncSizeRadio(false);
      }

      render();
      return true;
    }

    function scheduleRestore() {
      RESTORE_DELAYS.forEach(function (delay) {
        window.setTimeout(function () {
          restoreFromMemory();
        }, delay);
      });
    }

    customSelect.__customVariantRestore = scheduleRestore;

    function blockAddToCart(event) {
      if (isComplete()) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      setRequiredButton();
      showErrors();

      return false;
    }

    if (selectedBox) {
      selectedBox.setAttribute('tabindex', '0');
      selectedBox.setAttribute('role', 'button');
      selectedBox.setAttribute('aria-haspopup', 'listbox');

      selectedBox.addEventListener('click', function (event) {
        event.preventDefault();

        // Always rebuild options before opening.
        renderSizeOptions();

        customSelect.classList.toggle('open');
      }, { signal: signal });

      selectedBox.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          customSelect.classList.toggle('open');
        }

        if (event.key === 'Escape') {
          customSelect.classList.remove('open');
        }
      }, { signal: signal });
    }

    container
      .querySelectorAll('.tab-btn')
      .forEach(function (tab) {
        tab.addEventListener('click', function () {
          container
            .querySelectorAll('.tab-btn')
            .forEach(function (item) {
              item.classList.remove('active');
            });

          tab.classList.add('active');

          state.interacted = true;
          state.group = tab.dataset.tab || '';
          state.size = '';
          state.price = '';
          state.variantId = '';

          syncSizeRadio(false);
          saveState();
          render();
        }, { signal: signal });
      });

    picker.addEventListener('change', function (event) {
      var target = event.target;
      var group;
      var currentVariant;

      if (
        !target ||
        !target.matches('input[type="radio"], select') ||
        target === dropdown ||
        String(target.name || '').indexOf('properties[') === 0 ||
        target.closest('[data-product-property]')
      ) {
        return;
      }

      group = target.closest('[data-variant-option]');

      if (group) {
        setGroupLabel(group, target.value);
        group.classList.remove('variant-option-error');
      }

      if (isSizeGroup(group)) {
        if (syncingSize) return;

        currentVariant = findVariantBySize(target.value);

        if (currentVariant && currentVariant.available) {
          selectVariant(currentVariant);
        }

        return;
      }

      state.interacted = true;

      if (state.size) {
        currentVariant = findVariantBySize(state.size);

        if (currentVariant && currentVariant.available) {
          state.price = currentVariant.price;
          state.variantId = currentVariant.id;
        } else {
          state.size = '';
          state.price = '';
          state.variantId = '';
          syncSizeRadio(false);
        }
      }

      saveState();
      render();
    }, { signal: signal });

    document.addEventListener('click', function (event) {
      if (!customSelect.contains(event.target)) {
        customSelect.classList.remove('open');
      }
    }, { signal: signal });

    if (addButton) {
      addButton.addEventListener('click', blockAddToCart, {
        capture: true,
        signal: signal
      });
    }

    form.addEventListener('submit', blockAddToCart, {
      capture: true,
      signal: signal
    });

    if (!restoreFromMemory()) {
      clearDefaults();
      requestAnimationFrame(clearDefaults);
      window.setTimeout(clearDefaults, 100);
      window.setTimeout(clearDefaults, 300);
    } else {
      scheduleRestore();
    }
  }

  function initialize(root) {
    initCustomSizeSelector(root || document);
  }

  function start() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('quickadd:loaded', function (event) {
    initialize(
      event.detail && event.detail.content
        ? event.detail.content
        : event.target
    );
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener(
    'change',
    function (event) {
      var picker = event.target.closest &&
        event.target.closest('variant-selects');

      if (!picker) return;

      RESTORE_DELAYS.forEach(function (delay) {
        window.setTimeout(function () {
          initialize(getContainer(picker));
        }, delay);
      });
    },
    true
  );

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var mutationPicker =
        mutation.target &&
        mutation.target.closest &&
        mutation.target.closest('variant-selects');

      if (mutationPicker) {
        initialize(getContainer(mutationPicker));
      }

      mutation.addedNodes.forEach(function (node) {
        var picker;

        if (!node || node.nodeType !== 1) return;

        picker =
          (node.matches && node.matches('variant-selects') && node) ||
          (node.closest && node.closest('variant-selects')) ||
          (node.querySelector && node.querySelector('variant-selects'));

        if (
          picker
        ) {
          RESTORE_DELAYS.forEach(function (delay) {
            window.setTimeout(function () {
              initialize(getContainer(picker));
            }, delay);
          });
        }
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(() => {
  let variantRequestId = 0;
  let activeAbortController = null;

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  async function updateDropdownForSelectedColor() {
    const requestId = ++variantRequestId;

    if (activeAbortController) {
      activeAbortController.abort();
    }
    activeAbortController = new AbortController();
    const { signal } = activeAbortController;

    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;

    const productUrl =
      productInfo.dataset.url || window.location.pathname;

    const checkedControls = [
      ...productInfo.querySelectorAll(
        'input[type="radio"][data-option-value-id]:checked,' +
        'select[name^="options"] option:checked'
      )
    ];

    const optionValueIds = checkedControls
      .map((control) => control.dataset.optionValueId)
      .filter(Boolean);

    if (!sectionId || !optionValueIds.length) {
      console.error('Selected option value IDs not found');
      return;
    }

    const selectedColorInput = [
      ...productInfo.querySelectorAll(
        'input[type="radio"][data-option-value-id]:checked'
      )
    ].find((input) => {
      const name = normalize(input.name);

      return (
        name.includes('color') ||
        name.includes('colour') ||
        name.includes('spike')
      );
    });

    const selectedColor = normalize(selectedColorInput?.value);

    const requestUrl =
      `${productUrl}?section_id=${encodeURIComponent(sectionId)}` +
      `&option_values=${optionValueIds.join(',')}`;

    console.log('Loading variants for:', selectedColor, requestUrl);

    try {
      const response = await fetch(requestUrl, { signal });

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      const html = await response.text();

      if (requestId !== variantRequestId) return;

      const parsedDocument = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const fetchedDropdown =
        parsedDocument.querySelector('#SizeDropdown');

      const currentDropdown =
        productInfo.querySelector('#SizeDropdown');

      if (!fetchedDropdown || !currentDropdown) {
        console.error('Fetched/current SizeDropdown not found');
        return;
      }

      currentDropdown.innerHTML = fetchedDropdown.innerHTML;
      const customSelect = productInfo.querySelector('#CustomSizeSelect');
const picker = productInfo.querySelector('variant-selects');

if (customSelect) {
  
  if (customSelect.__customVariantAbort) {
    customSelect.__customVariantAbort.abort();
  }

  customSelect.dataset.initialized = 'false';

  delete customSelect.__customVariantPicker;
  delete customSelect.__customVariantRestore;
  delete customSelect.__customVariantAbort;

  const optionsBox = customSelect.querySelector('.custom-size-options');

  if (optionsBox) {
    optionsBox.innerHTML = '';
    optionsBox.style.removeProperty('display');
    optionsBox.style.removeProperty('height');
    optionsBox.style.removeProperty('visibility');
    optionsBox.style.removeProperty('opacity');
    optionsBox.style.removeProperty('pointer-events');
  }

  customSelect.classList.remove('open');
}


(productInfo || picker)?.dispatchEvent(
  new Event('shopify:section:load', {
    bubbles: true
  })
);

      const loadedColors = [
        ...new Set(
          [...currentDropdown.options].map((option) =>
            normalize(option.dataset.color)
          )
        )
      ];

      console.log('Dropdown replaced:', {
        selectedColor,
        loadedColors,
        optionCount: currentDropdown.options.length
      });

      if (typeof window.buildCurrentSizeOptions === 'function') {
        window.buildCurrentSizeOptions();
      } else if (
        typeof window.rebuildCustomSizeOptions === 'function'
      ) {
        window.rebuildCustomSizeOptions();
      }

      const availableOption = [
        ...currentDropdown.options
      ].find((option) => option.dataset.available === 'true');

      const addButton = productInfo.querySelector(
        'button[name="add"], .product-form__submit'
      );

      const productForm = addButton?.closest('form');
      const variantInput =
        productForm?.querySelector('input[name="id"]');

      if (availableOption && variantInput) {
        availableOption.selected = true;
        variantInput.value = availableOption.value;

        variantInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        if (addButton) {
          addButton.disabled = false;
          addButton.removeAttribute('aria-disabled');
        }
      } else {
        if (variantInput) {
          variantInput.value = '';
        }

        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
        }
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Color variant update failed:', error);
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest(
      'input[type="radio"][data-option-value-id]'
    );

    if (!input) return;

    const inputName = normalize(input.name);

    const isColorInput =
      inputName.includes('color') ||
      inputName.includes('colour') ||
      inputName.includes('spike');

    if (!isColorInput) return;

    updateDropdownForSelectedColor();
  });

  window.updateDropdownForSelectedColor =
    updateDropdownForSelectedColor;

  console.log('High-variant color updater applied');
})();
